<button
  [title]="Text()"
  mat-flat-button
  (click)="Click.emit()"
  [class]="['sheyda-menu-button', Appearance()]"
  [disabled]="disabled()"
>
  <ng-container *ngTemplateOutlet="buttonData" />
</button>

<ng-template #buttonData>
  <mat-icon>expand_more</mat-icon>
  @if (Text()) {
    <span>{{ Text() }}</span>
  }
</ng-template>
